import { Pipe, PipeTransform } from '@angular/core';
import { ImageContainer } from '@ui/orders/graphql';

@Pipe({
    name: 'unRetouchedFiles',
    standalone: false
})
export class UnRetouchedFilesPipe implements PipeTransform {
  transform(photoId: string, allGroups: ImageContainer[] | null): boolean {
    if (!photoId) {
      return false;
    }
    if (!allGroups) {
      return false;
    }
    return allGroups
      .flatMap((group) => group.images.files)
      .some(
        (file) => file.photo.photoId === photoId && !file.photo.isRetouched,
      );
  }
}
